import React from 'react';
import classes from 'classnames';
import { useStyles } from './ValidationError.styles';

interface ValidationErrorProps {
  message?: string;
  className?: string;
}

export const ValidationError: React.FC<ValidationErrorProps> = ({message, className}) => {
  const styles = useStyles();

  if (!message) {
    return null;
  }

  return (
    <div className={classes(styles.validationError, className)}>{message}</div>
  )
}
